import axios from 'axios'

/**
 * Instance axios dédiée à l'Espace Client B2B.
 * Base URL : /api (les routes client sont sous /api/client/...).
 */
const clientApi = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT + '/api',
})

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

clientApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.setItem('session_expired', 'true')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default clientApi
